import { Component, OnInit, Renderer2, AfterViewInit, OnDestroy, ViewChild, Input, HostListener } from '@angular/core';
import { MktCoopActionService } from '../../../services/mkt-coop-action.service';
import { MktCoopActionFilters, MktCoopBudgetResult } from '../../../models/mkt-coop-action';
import { DataTableDirective } from 'angular-datatables';
import { Subject, finalize } from 'rxjs';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { LanguageApp } from '../../../config/datatable-config';
import { saveAs } from 'file-saver';
import { MktCoopAnimationService } from '../../../services/mkt-coop-animation.service';
import { UserService } from '../../../services/user.service';
import { MktCoopFilterService } from '../../../services/mkt-coop-filter.service';


@Component({
  templateUrl: './mkt-coop-shared.component.html',
  styleUrls: ['./mkt-coop-shared.component.scss'],
  selector: 'app-mkt-coop',
})
export class MktCoopSharedComponent implements OnInit {

  @Input() fromLeapmotorzone = false;

  public meses: any[] = [];
  public anios: any[] = [];
  public types: any[] = [];
  public medias: any[] = [];
  public distributors: any[] = [];
  public status: any[] = [];
  public animations: any[] = [];
  public animationSelected;
  private resizeTimeout: any;
  activeAnimation: any[] = [];
  currentIdAnimation;
  totalConsumed: string;
  totalAsigned: string;
  animationTitle = '';
  public showCreateButton: boolean = false;

  budgetModel: MktCoopBudgetResult[] = [];


  filter: MktCoopActionFilters;
  tableFilter;


  listenerFn: () => void;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  @HostListener('window:resize')
  onResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      location.reload();
    }, 500);
  }

  constructor(private service: MktCoopActionService, private animationService: MktCoopAnimationService, private router: Router, private renderer: Renderer2,
    private filterService: MktCoopFilterService
  ) {
  }


  ngOnInit(): void {

    this.filter = this.filterService.filter;

    const toggleButton = document.getElementById("headingFilters").querySelector('[data-bs-toggle="collapse"]');
    if (toggleButton && this.filter.hasAnyValueSet()) {
      (toggleButton as HTMLElement).click();
    }


    this.getYearsAndMonth();
    this.getTypes();
    this.getMedias(this.filter.IdType ?? 0);
    this.getDistributors();
    this.getStatus();


    this.getAnimationsAndInitialize();
  }

  ngAfterViewInit(): void {
    this.listenerFn = this.renderer.listen('document', 'click', (event) => {
      if (this.fromLeapmotorzone == true) {
        if (event.target.hasAttribute("edit-mkt-coop-action-id")) {
          this.router.navigate(["leapmotor-zone/mkt-coop/edit/" + event.target.getAttribute("edit-mkt-coop-action-id")]);
        }
      } else {
        if (event.target.hasAttribute("edit-mkt-coop-action-id")) {
          this.router.navigate(["/mkt-coop/edit/" + event.target.getAttribute("edit-mkt-coop-action-id")]);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this.listenerFn) {
      this.listenerFn();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

  getAnimationsAndInitialize() {
    this.currentIdAnimation = this.filter.IdAnimation;
  
    this.animationService.GetAnimationSelect().subscribe({
      next: (res) => {
        this.animations = res;
        this.animationSelected = res.filter(o => o.active == true)[0]?.value || res[0]?.value;
        this.activeAnimation = res.filter(o => o.active == true);
  
        if (this.currentIdAnimation) {
          this.filter.IdAnimation = this.currentIdAnimation;
        } else {
          this.filter.IdAnimation = this.animationSelected;
        }
        
        this.getAnimationTitle();
        this.tableFilter = JSON.stringify([this.filter]);
        this.setDatatable();
        this.getBudget();
        
        this.updateShowCreateButton();
  
        setTimeout(() => {
          this.dtTrigger.next(null);
        });
      },
      error: (err) => {
        console.error('Error al obtener animaciones:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error al recuperar datos de animaciones',
          text: 'Ocurrió un error al cargar las animaciones'
        });
      }
    });
  }
  

  private updateShowCreateButton(): void {
    this.showCreateButton = this.activeAnimation.length > 0 && 
                            this.filter.IdAnimation == this.activeAnimation[0].value;
  }

  setDatatable() {
    const that = this;
    this.dtOptions = {
      ajax: (dataTablesParameters: any, callback) => {
        that.service
          .GetDatatable(dataTablesParameters, this.tableFilter)
          .subscribe(
            (resp) => {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: resp.data,
              });
            },
            (err) => {
              Swal.fire({
                icon: 'error',
                title: 'Error al recuperar los datos',
                text: 'Ocurrió un error',
              });
            }
          );
      },
      columns: [
        { data: 'CodDistributor', orderable: false },
        { data: 'Distributor', orderable: false },
        { data: 'Animation', orderable: false },
        { data: 'Period', orderable: false },
        { data: 'ValidationDate', orderable: false },
        { data: 'Status', orderable: false },
        { data: 'Type', orderable: false },
        { data: 'Media', orderable: false },
        { data: 'ExpectedAmountRead', orderable: false },
        { data: 'LeapmotorSubventionRead', orderable: false },
        { data: 'CommentsCount', orderable: false },
        { data: 'LeapmotorInvoiceUri', orderable: false },
        { data: 'IdAction', orderable: false },
      ],
      columnDefs: [
        {
          targets: [2],
          data: 'Animation',
          className: 'text-center'
        },
        {
          targets: [3],
          data: 'Period',
          render: function (data, type, full) {
            var retorno = '';
            retorno =
              '<div class="range_dates"><div><span class="medium-green"><strong>Inicio:</strong></span> <div class="medium-green">' +
              data.InitDate +
              '</div></div> <div><span class="red"><strong>Fin:</strong></span> <div class="red">' +
              data.EndDate +
              '</div></div></div>';
            return retorno;
          },
        },
        {
          targets: [5],
          data: 'Status',
          className: 'text-center',
          render: function (data, type, full) {
            var retorno = '';
            var statusId = parseInt(full.IdStatus, 10);
            var badgeClass = '';
            // Verificamos si 'statusId' es un número válido
            if (statusId === undefined) {
              console.log('Error: No se encontró "IdStatus" en "full"');
            } else {
              switch (statusId) {
                case 8:
                  badgeClass = 'status-expense-standby ';
                  break;
                case 9:
                  badgeClass = 'status-expense-approve';
                  break;
                case 10:
                  badgeClass = 'status-rejected';
                  break;
                case 11:
                  badgeClass = 'status-invoice-standby';
                  break;
                case 12:
                  badgeClass = 'status-invoice-approve';
                  break;
                case 13:
                  badgeClass = 'status-rejected';
                  break;
                default:
                  badgeClass = 'status-nodata'; // Clase por defecto si no coincide
                  break;
              }
            }
            retorno = `<div class="${badgeClass}">${data}</div>`;
            return retorno;
          },
        },
        {
          targets: [6],
          data: 'Type',
          render: function (data, type, full) {
            var retorno = '';
            var typeClass = '';
            // Asignar la clase según el tipo
            switch (full.Type) {
              case 'PUBLICIDAD LOCAL':
                typeClass = 'type-publicity';
                break;
              case 'JORNADA PUERTAS ABIERTAS':
                typeClass = 'type-doors';
                break;
              case 'ACCIONES VISIBILIDAD':
                typeClass = 'type-visibility';
                break;
              default:
                typeClass = 'type-default'; // Clase por defecto si no coincide
                break;
            }
            retorno = `<div class="cont_type_table">
                         <div class="${typeClass}"></div>
                         <span>${data}</span>
                       </div>`;
            return retorno;
          }
        }
        ,
        {
          targets: [8],
          data: 'ExpectedAmountRead',
          className: 'text-end',
          render: function (data, type, full) {
            if (typeof data === 'string') {
              data = data.replace('€', '€');
            }
            return data;
          },
        },
        {
          targets: [9],
          data: 'LeapmotorSubventionRead',
          className: 'text-end',
          render: function (data, type, full) {
            if (typeof data === 'string') {
              data = data.replace('€', '€');
            }
            return data;
          },
        },
        {
          targets: [10],
          data: 'CommentsCount',
          className: 'text-center',
          render: function (data, type, full) {
            var retorno = '';
            retorno += '<div class="counter_comments"><img src="../../../assets/images/icons/icon-comments.svg">' + data + '</div>';
            return retorno;
          },
        },
        {
          targets: [11],
          data: 'LeapmotorInvoiceUri',
          className: 'text-center',
          render: function (data, type, full) {
            var retorno = '';
            if (data) {
              retorno = '<a class="link-download" href="' + data + '">' + full.InvoiceNumber + '<img src="../../../assets/images/icons/icon-download-darkgreen.svg" alt="Descargar"></a>';
            }
            return retorno;
          },
        },
        {
          targets: [12],
          data: "IdAction",
          className: "text-end",
          render: function (data, type, full) {
            var retorno = "";
            retorno += '<a edit-mkt-coop-action-id="' + data + '" class="icon-btn"><i class="fa-solid fa-file-lines"></i></a>';
            return retorno;
          }
        }
      ],
      responsive: true,
      paging: true,
      pageLength: 10,
      ordering: true,
      lengthChange: false,
      info: false,
      serverSide: true,
      language: {
        paginate: {
          first: '<i class="fas fa-angle-double-left"></i>',
          last: '<i class="fas fa-angle-double-right"></i>',
          next: '<i class="fas fa-chevron-right"></i>',
          previous: '<i class="fas fa-chevron-left"></i>',
        },
      },
      processing: true,
    };
  }


  getYearsAndMonth() {
    this.service.GetYearsDashboard().subscribe(res => {
      res.unshift({ value: null, label: 'TODOS LOS AÑOS' })
      this.anios = res;
    });

    this.service.GetMonthsDashboard().subscribe(res => {
      res.unshift({ value: null, label: 'TODOS LOS MESES' })
      this.meses = res;
    });
  }

  getTypes() {
    this.service.GetTypesDashboard().subscribe(res => {
      res.unshift({ value: null, label: 'TODOS LOS TIPOS' })
      this.types = res;
    });
  }

  getMedias(idType) {
    this.service.GetMediasDashboard(idType ?? 0).subscribe(res => {
      res.unshift({ value: null, label: 'TODOS LOS MEDIOS ' })
      this.medias = res;
    });
  }

  getDistributors() {
    this.service.GetDistributorsDashboard().subscribe(res => {
      if (res.length == 1) {
        this.filter.IdDistributor = res[0].value;
      } else {
        res.unshift({ value: null, label: 'TODOS LOS CONCESIONARIOS' });
      }
      this.distributors = res;
    });
  }

  getStatus() {
    this.service.GetStatusDashboard().subscribe(res => {
      res.unshift({ value: null, label: 'TODOS LOS ESTADOS' })
      this.status = res;
    });
  }



  GetSelectedType(event) {
    this.getMedias(event.option.value);
  }

  filterData() {
    this.filterService.filter = this.filter;
    this.tableFilter = JSON.stringify([this.filter]);
    this.rerender();
    this.getBudget();
    this.getAnimationTitle();
    

    this.updateShowCreateButton();
  }
  
  resetData() {
    this.filter = new MktCoopActionFilters();
    this.filter.IdAnimation = this.animationSelected;
    this.filterService.filter = this.filter;
    this.tableFilter = JSON.stringify([this.filter]);
    this.rerender();
    this.getBudget();
    this.getAnimationTitle();
    

    this.updateShowCreateButton();
  }

  getBudget() {
    this.service.GetBudgetData(this.filter).subscribe(res => {
      this.budgetModel = res;

      var totalConsumed = this.budgetModel
        .map(o => o.TotalSpentConf)
        .reduce((acc, curr) => acc + curr, 0);

      var totalAsigned = this.budgetModel
        .map(o => o.TotalBudget)
        .reduce((acc, curr) => acc + curr, 0);

      this.totalConsumed = new Intl.NumberFormat('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true
      }).format(totalConsumed);

      this.totalAsigned = new Intl.NumberFormat('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true
      }).format(totalAsigned);
    })
  }

  DownloadExcelAction() {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor....'
    });

    Swal.showLoading();

    this.service.DownloadExcelAction(this.filter.IdAnimation).subscribe(blob => {
      var animationString = this.animations.find(o => o.value == this.filter.IdAnimation).label;
      saveAs(blob, "Liquidaciones " + animationString + '.xlsx');
      Swal.close();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error'
      });
    });
  }

  getAnimationTitle() {
    this.animationTitle = this.animations.find(o => o.value == this.filter.IdAnimation)?.label ?? 'no hay acciones activas';
  }
}